var ERRORS_CLEANUP_DELAY = 3000;
var MAX_TEXT_LENGTH = 512;

function cleanUpErrorMessage(type) {
  setTimeout(function () {
    $('.' + type + '-wrapper').find('.alert.alert-danger-light').remove();
  }, ERRORS_CLEANUP_DELAY);
}

function countCharacters($element) {
  var length = $element.val().length;
  var maxTextLength = $element.data('maxChars') || MAX_TEXT_LENGTH;

  if (length > maxTextLength) {
    $('.warning-limit').removeClass('hidden');
    var text = $element.val().substring(0, maxTextLength);
    $element.val(text);
    $('.charCount .chars-left').text('0 / ' + maxTextLength);
  } else {
    $('.warning-limit').addClass('hidden');
    $('.charCount .chars-left').text(maxTextLength - length + ' / ' + maxTextLength);
  }
}

function validatePlaceholder(textarea, placeholder) {
  var textValue = textarea[0].value;

  if (textValue.indexOf(placeholder) !== -1) {
    return true;
  }
}

function submitCheck(hasPlaceholders) {
  var submitBtn = $('form#tac-and-policy-form input[type="submit"]');

  if (hasPlaceholders) {
    submitBtn.prop('disabled', false);
  } else {
    submitBtn.prop('disabled', true);
  }
}

function placeholderCheck() {
  var placeholders = ['%{terms_and_conditions}', '%{privacy_policy}'];
  var textarea = $('form#tac-and-policy-form .locale_text');
  var hasPlaceholders = false;
  placeholders.forEach(function (placeholder) {
    if (validatePlaceholder(textarea, placeholder)) {
      hasPlaceholders = true;
    } else {
      hasPlaceholders = false;
    }
  });
  return submitCheck(hasPlaceholders);
}

function listenForDefaultLang(type) {
  var info_text = $('.' + type + '-list .input-info-text');
  var info_text_icon = $('.' + type + '-list .input-info-text .glyphicon');
  var table_text = $('.' + type + '-list .mt-20').find('.table-responsive');

  if ($('.' + type + '-list tr > td span.default-language').length || table_text.length === 0) {
    info_text.removeClass('warning-msg');
    info_text_icon.removeClass('glyphicon-warning-sign');
    info_text_icon.addClass('glyphicon-info-sign');
  } else {
    info_text.addClass('warning-msg');
    info_text_icon.removeClass('glyphicon-info-sign');
    info_text_icon.addClass('glyphicon-warning-sign');
  }
}

function removeTextById(id) {
  $('.' + id.substr(id.indexOf('-') + 1)).remove();
}

function footerTextRequest(href, type, requestType) {
  $.ajax({
    method: requestType,
    url: href,
    data: $('form#' + type + '-form').serialize(),
    dataType: 'html',
    success: function success(html) {
      $('.' + type + '-list').html($.parseHTML(html));
      $('form#' + type + '-form').trigger('reset');
      $('form#' + type + '-form select.locale-language').trigger('chosen:updated');
      cleanUpErrorMessage(type);
      listenForDefaultLang(type);
    }
  });
}

function create(id, href, type) {
  footerTextRequest(href, type, 'POST');
}

function update(id, href, type) {
  footerTextRequest(href, type, 'PUT');
}

function destroy(params) {
  var data = params.data;
  var type = data.type;
  $.ajax({
    method: data.request,
    url: data.href,
    success: function success(response) {
      if (!response.error) {
        removeTextById(params.targetId, type);
        listenForDefaultLang(type);
      }
    }
  });
}

function listenForEdit() {
  $(document).on('click', '.update-locale-text', function () {
    var text = $(this).data('url');
    var type = $(this).data('type');
    var $text_lang = $('form#' + type + '-form select.locale-language');
    var $textarea = $('form#' + type + '-form .locale_text');
    $text_lang.val(text.lang);
    $text_lang.trigger('chosen:updated');
    $textarea.val(text.text_value);
    $('form#' + type + '-form .default-language').prop('checked', text["default"]);
    countCharacters($textarea);
    $('#' + type + '-modal').on('shown.bs.modal', function () {
      var DELAY = 500;
      setTimeout(function () {
        $textarea.trigger('focus');
      }, DELAY);
    });
  });
}

function listenForBoundEvents() {
  $(document).on('click', '.create-text', function () {
    var type = $(this).data('type');
    var $textarea = $('form#' + type + '-form .locale_text');
    $('form#' + type + '-form').trigger('reset');
    $('form#' + type + '-form select.locale-language').trigger('chosen:updated');
    countCharacters($textarea);
  });
  $(document).on('click', '#policy-placeholder', function () {
    var textarea = $('form#tac-and-policy-form .locale_text');
    var word = '%{privacy_policy}';

    if (!validatePlaceholder(textarea, word)) {
      textarea.val(textarea.val() + ' ' + word);
      placeholderCheck();
    }
  });
  $(document).on('click', '#tac-placeholder', function () {
    var textarea = $('form#tac-and-policy-form .locale_text');
    var word = '%{terms_and_conditions}';

    if (!validatePlaceholder(textarea, word)) {
      textarea.val(textarea.val() + ' ' + word);
      placeholderCheck();
    }
  });
  $('textarea.locale_text').on('input propertychange', function () {
    countCharacters($(this));

    if ($(this).parents('form#tac-and-policy-form').length) {
      placeholderCheck();
    }
  });
}

var WpfLocaleText = {
  create: create,
  update: update,
  destroy: destroy,
  listenForEdit: listenForEdit,
  listenForBoundEvents: listenForBoundEvents
};
export default WpfLocaleText;